/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { APP_BASE_HREF } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { CoreModule } from './@core/core.module';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { ThemeModule } from './@theme/theme.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { Ng2ImgMaxModule } from 'ng2-img-max';
import { AngularFirestoreModule } from '@angular/fire/firestore';
import { AngularFireModule } from '@angular/fire';
import {
  AuthenticationService,
  ThemeService,
  CommonService,
  RestApiService
} from './services/index';

import * as firebase from "firebase/app";
import "firebase/firestore";
import { AngularFireAuthModule } from '@angular/fire/auth';

// const firebaseConfig = {
//   apiKey: "AIzaSyCIyQeN7G1tNHAA4l7l25o7lXZwvkoame8",
//   authDomain: "mast-244111.firebaseapp.com",
//   databaseURL: "https://mast-244111.firebaseio.com",
//   projectId: "mast-244111",
//   storageBucket: "mast-244111.appspot.com",
//   messagingSenderId: "115751459814",
//   appId: "1:115751459814:web:0a98deb2c877680c"
// };

const firebaseConfig = {
  apiKey: "AIzaSyCIyQeN7G1tNHAA4l7l25o7lXZwvkoame8",
  authDomain: "mast-244111.firebaseapp.com",
  databaseURL: "https://mast-244111.firebaseio.com",
  projectId: "mast-244111",
  storageBucket: "mast-244111.appspot.com",
  messagingSenderId: "115751459814",
  appId: "1:115751459814:web:0a98deb2c877680c",
  measurementId: "G-M32BF4ZY20"
};
firebase.initializeApp(firebaseConfig)

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    Ng2ImgMaxModule,
    NgbModule.forRoot(),
    ThemeModule.forRoot(),
    CoreModule.forRoot(),
    AngularFireModule.initializeApp(firebaseConfig),
    AngularFireAuthModule,
    AngularFirestoreModule,

  ],
  bootstrap: [AppComponent],
  providers: [
    { provide: APP_BASE_HREF, useValue: '/' },
    AuthenticationService,
    ThemeService,
    CommonService,
    RestApiService
  ],
})
export class AppModule {
}
